import classNames from 'classnames';
import { Dispatch, FC, SetStateAction, useCallback, useState } from 'react';
import { IntlShape, injectIntl } from 'react-intl';

import { ReactComponent as ArrowIcon } from '@app/pmi/src/assets/media/caret.svg';

import { localeCommon } from '@lib/tools/locale/source/pmi/common';
import { LocaleFragment } from '@lib/tools/locale/views/LocaleFragment';

import { getExpirationLabel } from '@components/pmi/src/utils';

interface ExpirationPeriodDropdownProps {
  period: { value: number; label: string };
  setPeriod: Dispatch<SetStateAction<{ value: number; label: string }>>;
  intl: IntlShape;
}

const ExpirationPeriodDropdown = ({ period, setPeriod, intl }: ExpirationPeriodDropdownProps) => {
  const [isVisible, setIsVisible] = useState(false);

  const periodArr = [
    { label: getExpirationLabel(1, intl), value: 1 },
    { label: getExpirationLabel(2, intl), value: 2 },
    { label: getExpirationLabel(3, intl), value: 3 },
    { label: getExpirationLabel(4, intl), value: 4 },
    { label: getExpirationLabel(5, intl), value: 5 },
    { label: getExpirationLabel(6, intl), value: 6 },
    { label: getExpirationLabel(7, intl), value: 7 },
  ];

  const chosePeriod = useCallback(item => {
    setPeriod(item);
    setIsVisible(false);
  }, []);

  return (
    <div className="dropdown-select">
      <button
        className="text-capitalize dropdown-toggle-select text-left font-ta-v2-global-body-small"
        type="submit"
        onClick={() => setIsVisible(!isVisible)}
      >
        {getExpirationLabel(period.value, intl)}
        <ArrowIcon
          className={classNames('toggle-icon-select', {
            open: isVisible,
          })}
        />
      </button>
      <div
        className={classNames('dropdown-menu-select', {
          open: isVisible,
        })}
      >
        {periodArr.map(item => (
          <button
            key={item.value}
            className="dropdown-menu-select-btn font-ta-v2-global-body-small"
            type="button"
            value={item.value}
            onClick={() => {
              chosePeriod(item);
            }}
            onKeyDown={() => {
              chosePeriod(item);
            }}
          >
            <p className="mb-0 text-capitalize">{item.label}</p>
          </button>
        ))}
      </div>
    </div>
  );
};

export const ExpirationPeriodDropdownWithIntl = injectIntl(ExpirationPeriodDropdown);

interface Props {
  expiryHoursValue: string | null;
  setSelectedExpirationPeriod: Dispatch<SetStateAction<{ value: number; label: string }>>;
  selectedExpirationPeriod: { value: number; label: string };
}

export const ExpirationPeriod: FC<Props> = ({
  expiryHoursValue,
  setSelectedExpirationPeriod,
  selectedExpirationPeriod,
}) => (
  <div className="d-flex flex-column text-description">
    <span className="text-capitalize margin-bottom-5px">
      <LocaleFragment message={localeCommon.accessKeyGenerator.expirationPeriod} />
      *: &nbsp;
    </span>
    <span className="text-uppercase">
      {expiryHoursValue ? (
        <span className="text-capitalize">
          {expiryHoursValue}
          &nbsp;
          <LocaleFragment message={localeCommon.accessKeyGenerator.hours} />
        </span>
      ) : (
        <ExpirationPeriodDropdownWithIntl period={selectedExpirationPeriod} setPeriod={setSelectedExpirationPeriod} />
      )}
    </span>
  </div>
);
